let header;
let langList;
let langListOverlay;
let langSelect;
let langSelectMobile;
let langListMobile;

if (document.querySelector('.header')) {
	header = document.querySelector('.header');
}

if (header) {
	langList = header.querySelector('.header__lang-list');
	langListOverlay = header.querySelector('.header__lang-overlay');
	langSelect = header.querySelector('.header__lang-select');

	langListMobile = header.querySelector('.header__lang-list-mobile');
	langSelectMobile = header.querySelector('.header__lang-select-mobile');
}

const langListActive = () => {
	langList.classList.add('grid');
	langListMobile.classList.add('grid');
	langListOverlay.classList.add('block');

	setTimeout(() => {
		langList.classList.add('active');
		langListMobile.classList.add('active');
	}, 10);
};

const langListDeActive = () => {
	langList.classList.remove('active');
	langListMobile.classList.remove('active');

	setTimeout(() => {
		langList.classList.remove('grid');
		langListMobile.classList.remove('grid');
		langListOverlay.classList.remove('block');
	}, 200);
};

const langListOpen = () => {
	if (langList.classList.contains('active')) {
		langListDeActive();
	} else {
		langListActive();
	}
};

const langInit = () => {
	if (langList) {
		langSelect.addEventListener('click', () => {
			langListOpen();
		});

		langSelectMobile.addEventListener('click', () => {
			langListOpen();
		});

		langListOverlay.addEventListener('click', () => {
			langListOpen();
		});
	}
};

export default langInit;
